import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import 'moment/locale/tr';
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import ConnectorExCustomerModal from "./ConnectorExCustomerModal";
import {request} from "../../../helper/APIUtils";
import {UncontrolledTooltip} from "reactstrap";


class ConnectorExternalCustomer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error : {},
			modal: false,
			invoicePkList: [],
			despatchPkList: []
		};

	}

	componentWillMount() {
		let externalCustomer = this.props.externalCustomer;
		this.setState({externalCustomer: externalCustomer});
		this.fetchPkList(externalCustomer);
	}

	setDocExternalCustomer = (docExternalCustomer) =>{
		this.setState({docExternalCustomer:docExternalCustomer,modal:false});
	}

	onChangeExternalCustomer = (e) => {
		let externalCustomer = deepCopyObject(this.state.externalCustomer);
		externalCustomer[e.target.name] = e.target.value;
		if (e.target.name === "title") {
			this.setState({externalCustomer: externalCustomer, currentTitle: e.target.value});
		} else if(e.target.name=== "formattedName"){
			e.target.value = e.target.value.replace(/ +(?= )/g,'');
			externalCustomer[e.target.name] = e.target.value;
		}
		this.setState({externalCustomer: externalCustomer});

	}
	onChange = (e) => {
		let self = this;
		let externalCustomer = deepCopyObject(this.state.externalCustomer);
		externalCustomer[e.target.name] = e.target.value;
		self.setState({externalCustomer});
		self.props.listener(externalCustomer);

	}
	validateClass = (id) => {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}
	validateMessage = (id) => {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	fetchPkList = (content) => {
		if (content.vknTckn) {
			let self = this;
			let params = {
				url: '/externalCustomer/fetchPkList',
				data: content.vknTckn,
				method: 'post'
			};
			request(params).then((response) => {
				let pkList = response.data;
				let invoicePkList = [];
				let despatchPkList = [];
				let externalCustomer = deepCopyObject(this.state.externalCustomer);
				if (pkList.length !== 0) {
					invoicePkList = pkList.filter(pk => pk.documentType === 'Invoice');
					if (invoicePkList.length !== 0) {
						externalCustomer.postboxAlias = invoicePkList[0].aliasName;
					}

					despatchPkList = pkList.filter(pk => pk.documentType === 'DespatchAdvice');
					if (despatchPkList.length !== 0) {
						externalCustomer.despatchPostboxAlias = despatchPkList[0].aliasName;
					}
				}
				self.setState({pkList: response.data, invoicePkList, despatchPkList});
			}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}
	render() {
		const {externalCustomer} = this.state
		return (
			<div className="row">

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>VKN</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("vknTckn")}>
							<input className="form-control"
								   type="text"
								   minLength={10}
								   maxLength={11}
								   name = "vknTckn"
								   value={externalCustomer.vknTckn || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Unvan</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("formattedName")}>
							<input className="form-control"
								   type="text"
								   name = "formattedName"
								   value={externalCustomer.formattedName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Ülke</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("countryName")}>
							<input className="form-control"
								   type="text"
								   name="countryName"
								   value={externalCustomer.countryName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Adı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("givenName")}>
							<input className="form-control"
								   type="text"
								   name="givenName"
								   value={externalCustomer.givenName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>İl</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("cityName")}>
							<input className="form-control"
								   type="text"
								   name="cityName"
								   value={externalCustomer.cityName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Soyadı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("familyName")}>
							<input className="form-control"
								   type="text"
								   name="familyName"
								   value={externalCustomer.familyName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>İlçe</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("citySubdivisionName")}>
							<input className="form-control"
								   type="text"
								   name="citySubdivisionName"
								   value={externalCustomer.citySubdivisionName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Email</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("email")}>
							<input className="form-control"
								   type="text"
								   name="email"
								   value={externalCustomer.email || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Sokak</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("streetName")}>
							<input className="form-control"
								   type="text"
								   name="streetName"
								   value={externalCustomer.streetName || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Fax</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("fax")}>
							<input className="form-control"
								   type="text"
								   name="fax"
								   value={externalCustomer.fax || ""}
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Posta Kodu</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("postalZone")}>
							<input className="form-control"
								   type="text"
								   value={externalCustomer.postalZone || ""}
								   name="postalZone"
								   onChange={(e) => this.onChange(e)}
							/>
						</div>
					</div>
				</div>
				{this.props.docType === "EARSIVFATURA" && this.props.taxInclusiveAmount >= 9900 &&
					<div style={{marginRight: '0', marginTop:'20px', padding: '0 0 0 15px'}}>
						<div>
							<label style={{wordWrap: 'break-word', whiteSpace: 'normal',color: 'red'}}>
								<i className="fas fa-exclamation-circle" style={{color: 'red', marginRight: '8px'}}></i>
								2025 yılı itibarıyla, 9.900 TL ve üzeri faturalar için alıcının adı, soyadı
								ve TC kimlik numarası (veya firma adı ve VKN) zorunludur. Bu bilgileri sağlamadan bu tür faturalar kesilemez.
							</label>
						</div>
					</div>
				}

				{(this.props.docType === 'IHRACAT') && (
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Alıcı Türü *</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass('buyerType')}>
								<Select id="buyerType"
										name="buyerType"
										placeholder="Seçiniz..."
										value={externalCustomer.buyerType}
										clearable={false}
										noResultsText="Kayıt bulunamadı."
										onChange={(e) => e && this.onChange({target: {name: "buyerType", value: e.value}})}
										options={[{value: "OZEL", label: "Özel"}, {value: "TUZEL", label: "Tüzel"}]}
								/>
								{this.validateMessage('buyerType') !== "" &&
									<UncontrolledTooltip placement="right" target="buyerType" delay={0}>
										{this.validateMessage("buyerType")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				)}
				{(this.props.docType === 'TEMELFATURA' || this.props.docType === 'TICARIFATURA' || this.props.docType === 'TEMELIRSALIYE' || this.props.docType === 'IHRACAT') &&
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label className="col-form-label">Alıcı Etiketi: </label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<Select
								className="select-control"
								name='postboxAlias'
								clearable={false}
								value={externalCustomer.postboxAlias}
								noResultsText="Kayıt bulunamadı."
								placeholder="Seçiniz..."
								onChange={(e) => this.onChange({
									target: {
										value: e && e.value,
										name: 'postboxAlias'
									}
								})}
								options={this.state.invoicePkList.map(pk => ({
									value: pk.aliasName,
									label: pk.aliasName
								}))}
							/>
							{this.validateMessage("postboxAlias") !== "" &&
								<UncontrolledTooltip placement="right" target="postboxAlias" delay={0}>
									{this.validateMessage("postboxAlias")}
								</UncontrolledTooltip>}
						</div>
					</div>
				}

				{this.state.modal &&
				<ConnectorExCustomerModal type={null}
									   title="Kişi Bilgileri"
									   listener={this.setDocExternalCustomer}
									   modal={this.state.modal}
									   cities={this.props.cities}
									   countries={this.props.countries}
									   docExternalCustomer={this.state.externalCustomer}
									   />
				}
			</div>
		);
	}
}

export default ConnectorExternalCustomer;